import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default () => {
	const wrappers = gsap.utils.toArray(".scrolling-stackable__wrapper");
	const cards = gsap.utils.toArray(".scrolling-stackable__box");

	wrappers.forEach((wrapper, i) => {
		const card = cards[i];

		let scale = 1,
			rotation = 0;

		// Apply scaling only to earlier cards
		if (i !== cards.length - 1) {
			scale = 0.9 + 0.025 * i;
			rotation = -10;
		}

		gsap.matchMedia().add("(max-width: 768px)", () => {
			gsap.to(card, {
				scale: scale,
				transformOrigin: "top center",
				ease: "none",
				scrollTrigger: {
					trigger: wrapper,
					start: () => `top ${window.innerHeight * 0.15 + 10 * i}`, // Adjusted for mobile
					end: "bottom 550",
					endTrigger: ".scrolling-stackable__container",
					scrub: true,
					pin: wrapper,
					pinSpacing: false,
					id: i + 1
				}
			});
		});

		gsap.matchMedia().add("(min-width: 769px)", () => {
			gsap.to(card, {
				scale: scale,
				transformOrigin: "top center",
				ease: "none",
				scrollTrigger: {
					trigger: wrapper,
					start: () => `top ${window.innerHeight * 0.3 + 10 * i}`, // Original start position
					end: "bottom 550",
					endTrigger: ".scrolling-stackable__container",
					scrub: true,
					pin: wrapper,
					pinSpacing: false,
					id: i + 1
				}
			});
		});
	});
};
